<li class="list-inline-item dropdown notification-list show">
  <a
    aria-hidden="true"
    class="nav-link arrow-none waves-light waves-effect"
    (click)="toggleMenu()"
  >
    <i class="pi pi-bell" aria-hidden="true"></i>
    @if (getUnreadCount()) {
      <span class="noti-icon-badge">{{ getUnreadCount() }}</span>
    }
  </a>
  <div
    class="dropdown-menu dropdown-menu-right dropdown-arrow dropdown-lg"
    [class.visible]="isVisible"
  >
    <!-- header -->
    <div class="noti-header">
      <div class="noti-header-title">
        <span class="noti-header-label">Notifications</span>
        @if (getUnreadCount()) {
          <span class="noti-header-badge">{{ getUnreadCount() }}</span>
        }
      </div>
      <button
        type="button"
        class="noti-header-close"
        aria-label="Close"
        (click)="toggleMenu()"
      >
        <i class="pi pi-times" aria-hidden="true"></i>
      </button>
    </div>

    <div class="noti-list">
      @if (!notifications.length) {
        <p class="empty-list">You don't have new notifications</p>
      }

      @for (notification of notifications; track notification) {
        <a
          aria-hidden="true"
          class="notify-item"
          [class.read]="notification.isRead()"
          (click)="openNotification(notification)"
        >
          <div class="notify-icon">
            <i class="pi pi-info-circle" aria-hidden="true"></i>
          </div>
          <small class="notify-time">{{
            notification.createdAt | timeAgo
          }}</small>
          <strong class="notify-title">{{ notification.title }}</strong>
          <div
            class="notify-body"
            [innerHTML]="notification.body | safeHtml"
          ></div>
        </a>
      }
    </div>
  </div>
</li>
